import { Modal, Form, Input, Button, Space } from "antd";
import { PlusCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSolicitud } from "../../../context/actions/solicitudesActions";

const { TextArea } = Input;

export const ModalCrearSolicitud = ({ visible, onClose }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  
  const { creandoSolicitud } = useSelector(state => state.solicitudesReducer);

  const handleSubmit = async (values) => {
    setLoading(true);
    
    try {
      const result = await dispatch(createSolicitud(values));
      
      if (result && result.success) {
        form.resetFields();
        // Cerrar modal automáticamente después de 2 segundos
        setTimeout(() => {
          onClose();
        }, 2000);
      }
    } catch (error) {
      // Error manejado silenciosamente
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Nueva Solicitud de Atención"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={600}
      className="modal-crear-solicitud"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        requiredMark={false}
      >
        <Form.Item
          name="comentario"
          label="Descripción de la solicitud"
          rules={[
            { required: true, message: "Por favor ingresa la descripción" },
            { min: 10, message: "La descripción debe tener al menos 10 caracteres" },
            { max: 500, message: "La descripción no puede exceder 500 caracteres" }
          ]}
        >
          <TextArea
            rows={6}
            placeholder="Describe detalladamente tu solicitud o problema..."
            showCount
            maxLength={500}
          />
        </Form.Item>

        <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '24px' }}>
          <Button 
            onClick={handleCancel}
            icon={<CloseOutlined />}
          >
            Cancelar
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading || creandoSolicitud}
            className="gradient-button"
            icon={<PlusCircleOutlined />}
          >
            Crear Solicitud
          </Button>
        </div>
      </Form>
    </Modal>
  );
};